const endpoints = {
    base: 'https://hubdev.tnc.org/api'
};

export const environment = {
    production: false,
    name: 'Hub (Development)',
    endpoints,
    algolia: {
        appId: 'WRFJJH1WEP',
        portfolioSearch: {
            indexName: 'dev_hub4_portfoliosearch',
            routing: true,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/dev_hub4_portfoliosearch`
        },
        projectNameSearch: {
            indexName: 'dev_hub4_projectnames',
            routing: false,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/dev_hub4_projectnames`
        },
        collectionSearch: {
            indexName: 'dev_hub4_projectcollectionsearch',
            routing: false,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/dev_hub4_projectcollectionsearch`
        },
        fundraisingMenuSearch: {
            indexName: 'dev_hub4_fundraisingmenu',
            routing: true,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/dev_hub4_fundraisingmenu`
        },
        userAdministration: {
            indexName: 'dev_hub4_user',
            routing: true,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/dev_hub4_user`
        },
        projectAtTncSearch: {
            indexName: 'css_dev_projectsattnc',
            routing: true,
            temporarySecretKeyEndpoint: `${endpoints.base}/AlgoliaKey/css_dev_projectsattnc`
        }
    },
    auth: {
        tenant: '79be6dc1-d78e-4bbb-b22b-d994c0a417a7',
        clientId: 'a0680fbb-f6c4-4652-b439-6b2636b4141a',
        redirectUri: 'https://hubdev.tnc.org/auth-callback',
        domain: 'hubdev.tnc.org',
        requireHttpsProtocol: true,
        endpoints: {
            'https://localhost/61642': '767fb58b-cde9-42b1-8881-44665d5a9c81',
            'https://localhost/8080': '767fb58b-cde9-42b1-8881-44665d5a9c81'
        }
    },
    errorHandling: {
        display: {
            autohide: {
                delayInSeconds: 3
            },
            showStackTrace: true
        },
        logging: null
    },
    arcGISOnlineApiKey: 'AAPTaKNsaQoFCyHej4AZwHhxQbw..YnHBGcwBhgYad4rVUNo0I22mj2wiGW85qWvJmdeV0J3ly5yX6iOkBKJlP6PNxXBM_7UIkV8jfD70r8Xge1M2LZ_zOPx_7v9_pmhjriN_R8IHjWCQC3Kin2iRREiKAD3tv_y7yeSYHvMCBmPO817Too67im9q1Od0sCgiGon3ouVnqIU0jHTl48PgMYRwYJfRmG2Oe4w8j4iLeGtsWFrwe2sa2XKM2CV2bUlQO-FS9z2G2w2oeEdvwzZRnsu1lG0AqU0NlvRVAT1_VSNsUE8q',
    showNonProdNotification: true,
    appInsights: {
        connectionString: 'InstrumentationKey=01123c71-f83b-4a6f-85f3-011ea00ebe73;IngestionEndpoint=https://eastus-1.in.applicationinsights.azure.com/'
    },
    timers: {
        showWarningBeforeTimeoutInMinutes: 5
    },
    amCharts: {
        license: 'CH304356357'
    },
    featureToggles: {}
};
